<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditHelpCenterModal"
        persistent
        scrollable
        max-width="1100px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? $t('helpCenter.updateTitle') : $t('datatable.addNewHelpCenterButton') }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
                    <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
                  </span>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <!-- Questions row -->
              <div class="row">
                <div class="col-md-4">
                  <v-text-field
                    :label="$t('helpCenter.questionEnLabel') + '*'"
                    v-model="formData.question_en"
                    :error-messages="errors.collect('question_en')"
                    v-validate="'required|max:500'"
                    data-vv-name="question_en"
                    counter="500"
                    maxlength="500"
                  />
                </div>
                <div class="col-md-4">
                  <v-text-field
                    :label="$t('helpCenter.questionArLabel')"
                    v-model="formData.question_ar"
                    :error-messages="errors.collect('question_ar')"
                    v-validate="'max:500'"
                    data-vv-name="question_ar"
                    counter="500"
                    maxlength="500"
                  />
                </div>
                <div class="col-md-4">
                  <v-text-field
                    :label="$t('helpCenter.questionKuLabel')"
                    v-model="formData.question_ku"
                    :error-messages="errors.collect('question_ku')"
                    v-validate="'max:500'"
                    data-vv-name="question_ku"
                    counter="500"
                    maxlength="500"
                  />
                </div>
              </div>

              <!-- Answers row -->
              <div class="row" style="margin-top: 8px;">
                <div class="col-md-4">
                  <label :style="{ color: answerEnError ? 'red' : 'inherit', opacity: answerEnError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: 4px; display: block;">{{ $t('helpCenter.answerEnLabel') }}*</label>
                  <textarea v-model="formData.answer_en" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem;" rows="5"></textarea>
                  <div v-if="answerEnError" style="color: red; font-size: 12px; margin-top: 2px;">{{ answerEnError }}</div>
                </div>
                <div class="col-md-4">
                  <label style="font-size: 14px; margin-bottom: 4px; display: block; opacity: 0.8;">{{ $t('helpCenter.answerArLabel') }}</label>
                  <textarea v-model="formData.answer_ar" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem;" rows="5"></textarea>
                </div>
                <div class="col-md-4">
                  <label style="font-size: 14px; margin-bottom: 4px; display: block; opacity: 0.8;">{{ $t('helpCenter.answerKuLabel') }}</label>
                  <textarea v-model="formData.answer_ku" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem;" rows="5"></textarea>
                </div>
              </div>

              <!-- Order & Active row -->
              <div class="row" style="margin-top: 8px; align-items: center;">
                <div class="col-md-6">
                  <v-text-field
                    :label="$t('columns.order')"
                    v-model="formData.order"
                    :error-messages="errors.collect('order')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="order"
                  >
                    <template v-slot:append>
                      <v-icon small @click="formData.order++">mdi-plus</v-icon>
                      <v-icon small @click="formData.order > 1 ? formData.order-- : 1">mdi-minus</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="col-md-6" style="display: flex; align-items: center; padding-top: 8px;">
                  <v-switch
                    :label="$t('helpCenter.isActiveLabel')"
                    v-model="formData.is_active"
                    color="success"
                    hide-details
                  ></v-switch>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditHelpCenterModal', 'formData', 'isUpdate'],

  data() {
    return {
      loading: false,
      answerEnError: ''
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.answerEnError = ''
      this.$emit('close')
    },

    submitForm() {
      this.answerEnError = ''
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (!this.formData.answer_en || !this.formData.answer_en.trim()) {
          this.answerEnError = this.$t('helpCenter.answerEnRequiredError')
          res = false
        }
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/help-center/${this.formData.help_center_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/help-center', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/helpCenter/addEditHelpCenter.vue